/**
 * Locale translations: ar (Arabic).
 * Keys and structure are shared across all locale files.
 */
export const ar = {
  // Common
  common: {
    loading: "جاري التحميل...",
    error: "خطأ",
    sort: "فرز",
    sortAsc: "فرز تصاعدي",
    sortDesc: "فرز تنازلي",
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
    remove: "إزالة",
    edit: "تعديل",
    view: 'عرض',
    copy: "نسخ",
    create: "إنشاء",
    update: "تحديث",
    search: "بحث",
    actions: "إجراءات",
    code: "رمز",
    all: "الكل",
    clear: "مسح",
    filter: "تصفية",
    yes: "نعم",
    no: "لا",
    confirm: "تأكيد",
    close: "إغلاق",
    select: "اختيار",
    active: "نشط",
    inactive: "غير نشط",
    success: "نجاح",
    updated: "تم التحديث",
    created: "تم الإنشاء",
    deleted: "تم الحذف",
    confirmDelete: "هل أنت متأكد من الحذف؟",
    errorOccurred: "حدث خطأ ما",
    noData: "لا توجد بيانات",
    status: "الحالة",
    show: "عرض",
    hide: "إخفاء",
    searchPlaceholder: "بحث...",
    allStatuses: "جميع الحالات",
    clearFilters: "مسح التصفية",
    newRecord: "سجل جديد",
    noPermission: "ليس لديك صلاحية",
    statusDistribution: "توزيع الحالات",
    rows: "صفوف",
    firstPage: "الصفحة الأولى",
    previousPage: "الصفحة السابقة",
    nextPage: "الصفحة التالية",
    lastPage: "الصفحة الأخيرة",
    page: "صفحة",
    optional: "اختياري",
    saving: "جاري الحفظ...",
    deleteConfirmTitle: "تأكيد الحذف",
    deleteWarning: "هذا الإجراء لا يمكن التراجع عنه!",
    autoTranslate: "ترجمة تلقائية",
    autoTranslateSuccessCount: "تمت ترجمة {count} عناصر تلقائيًا.",
    autoTranslateNoSource: "لم يتم العثور على ترجمة المصدر.",
    enterTargetLanguage: "يرجى اختيار اللغة المستهدفة.",
    sourceLanguageLabel: "لغة المصدر (واجهتك)",
    targetLanguage: "اللغة المستهدفة",
    sourceAndTargetMustDiffer: "يجب أن تختلف لغة المصدر عن اللغة المستهدفة.",
    context: "السياق",
    key: "المفتاح",
    value: "القيمة",
    locale: "اللغة",
    auto: "تلقائي",
    manual: "يدوي",
    manageLocales: "إدارة اللغات",
    activeLocalesDescription: "اختر اللغات النشطة. سيتم حفظها كإعداد فقط.",
    updateUntranslatedFields: "مزامنة الحقول الجديدة",
    syncEntriesResult: "تمت مزامنة {count} من إدخالات الترجمة الجديدة.",
    syncDeletedResult: "تم حذف {count} من الإدخالات القديمة.",
    selectSourceLanguageForSync: "ما هي لغة المحتوى؟",
    sourceLanguage: "لغة المصدر",
    originalShort: "الأصل",
    languageNames: { en: "الإنجليزية", tr: "التركية", de: "الألمانية", fr: "الفرنسية", es: "الإسبانية", ar: "العربية", it: "الإيطالية", ja: "اليابانية", zh: "الصينية", ru: "الروسية" } as Record<string, string>,
    perPage: "لكل صفحة",
    darkMode: "الوضع الداكن",
    lightMode: "الوضع الفاتح",
    copyright: "© {year} QubePro. جميع الحقوق محفوظة.",
    translationRates: "معدلات الترجمة",
    profileMenu: "قائمة الملف الشخصي",
    manageYourAccount: "إدارة حسابك",
    adminConsole: "لوحة تحكم المسؤول",
    serverConfiguring: "جاري تهيئة الخادم، يرجى الانتظار...",
    productName: "الإدارة",
  },

  portal: {
    searchPlaceholder: "البحث عن التطبيقات...",
    noAppsFound: "لم يتم العثور على تطبيقات.",
    quickLinks: "روابط سريعة",
    console: "لوحة تحكم المسؤول",
    lastLogin: "آخر تسجيل دخول",
    apps: {
      core: { name: "الإدارة", description: "إدارة الشركات والمؤسسات والمستخدمين والأدوار والصلاحيات في نظام مركزي." },
      bi: { name: "التحليلات", description: "إنشاء تقارير ولوحات معلومات من بياناتك. تحويل البيانات إلى أفكار." },
      bpm: { name: "العمليات", description: "بدء وتتبع الطلبات الداخلية والموافقات والمهام في بيئة رقمية." },
      support: { name: "الدعم", description: "إدارة طلبات العملاء والتذاكر. تتبع وحل المشكلات في مكان واحد." },
      agent: { name: "الأتمتة", description: "أتمتة المهام الروتينية باستخدام الروبوتات والوكلاء. يتكامل مع أدواتك." },
      ai: { name: "الذكاء الاصطناعي والتنبؤ", description: "استخدام نماذج الذكاء الاصطناعي لتحليل البيانات والتنبؤ. تحسين التخطيط والقرارات." },
      erp: { name: "مجموعة الأعمال", description: "وحدات للمالية والمبيعات والمخزون والعمليات. أدر عملك من مكان واحد." },
      pms: { name: "المشاريع", description: "تخطيط المشاريع وتعيين المهام وتتبع التقدم والتعاون مع الفريق." },
      crm: { name: "العملاء", description: "إدارة جهات الاتصال والفرص والصفقات ومسارات المبيعات." },
    },
    menus: {
      core_dashboard: "لوحة التحكم",
      core_companies: "الشركات",
      core_organizations: "المؤسسات",
      core_roles: "الأدوار",
      core_users: "المستخدمين",
      core_groups: "المجموعات",
      core_emails: "حسابات البريد",
      core_data_sources: "مصادر البيانات",
      core_settings_company: "إعدادات الشركة",
      core_settings_user: "إعدادات المستخدم",
      core_translations: "الترجمات",
    },
  },

  panel: {
    apps: {
      crm: { name: "CRM", footerName: "CRM" },
      accounting: { name: "المحاسبة" },
      finance: { name: "المالية" },
      procurement: { name: "المشتريات" },
      inventory: { name: "المخزون" },
      purchase: { name: "المشتريات" },
      sales: { name: "المبيعات" },
      manufacturing: { name: "التصنيع" },
      assets: { name: "الأصول" },
      hr: { name: "الموارد البشرية" },
      project: { name: "إدارة المشاريع" },
      timesheet: { name: "سجل الوقت" },
      documents: { name: "المستندات" },
      pos: { name: "نقاط البيع" },
      rental: { name: "تأجير" },
      dashboard: { name: "التقارير" },
    },
    appsLabel: "التطبيقات",
    settingsLabel: "الإعدادات",
    coreLabel: "الإدارة",
    backToHome: "العودة للرئيسية",
  },

  errors: {
    unknown: "حدث خطأ غير معروف",
    network: "لا يمكن الاتصال بالخادم. تحقق من اتصال الإنترنت.",
    timeout: "انتهت مهلة الانتظار. يرجى المحاولة مرة أخرى.",
    badRequest: "طلب غير صالح",
    unauthorized: "انتهت الجلسة. يرجى تسجيل الدخول مرة أخرى.",
    forbidden: "ليس لديك صلاحية للقيام بهذا الإجراء.",
    notFound: "المورد المطلوب غير موجود",
    tooManyRequests: "طلبات كثيرة جدًا. يرجى المحاولة لاحقًا.",
    internalServerError: "خطأ في الخادم. يرجى المحاولة لاحقًا.",
    badGateway: "الخادم غير متاح مؤقتًا",
    serviceUnavailable: "الخدمة غير متاحة مؤقتًا",
    gatewayTimeout: "الخادم لا يستجيب",
    serverErrorWithStatus: "خطأ في الخادم ({status})",
  },

  // Dashboard
  dashboard: {
    title: "لوحة التحكم",
    subtitle: "نظرة عامة على نظام الإدارة المركزي",
    welcome: "مرحباً",
    guestName: "ضيف",
    statusSummary: "ملخص الحالة الحالية",
    currentTimeLabel: "الوقت الحالي",
    todayLabel: "اليوم",
    activeCompanies: "الشركات النشطة",
    activeOrganizations: "المؤسسات النشطة",
    activeUsers: "المستخدمون النشطون",
    activeRoles: "الأدوار النشطة",
    database: "قاعدة البيانات",
    databaseUsed: "المساحة المستخدمة",
    recentlyAddedUsers: "المستخدمون المضافون مؤخراً",
    recentlyAddedCompanies: "الشركات المضافة مؤخراً",
    noUsersYet: "لا يوجد مستخدمون بعد",
    noCompaniesYet: "لا توجد شركات بعد",
    userPanel: "لوحة المستخدم",
    userPanelWelcome: "مرحباً! يمكنك الوصول لإعدادات المستخدم من القائمة.",
    quickActions: "إجراءات سريعة",
    systemHealthTitle: "حالة النظام",
    systemLogsTitle: "سجلات النظام",
    logChartTitle: "توزيع الأخطاء/التحذيرات",
    logErrorsLabel: "أخطاء",
    logWarningsLabel: "تحذيرات",
    logSuccessLabel: "نجاح",
    statusHealthy: "سليم",
    statusFailed: "فشل",
    statusUnknown: "غير معروف",
    lastRun: "آخر تشغيل",
    failures24h: "إخفاقات 24 ساعة",
    noData: "لا توجد بيانات",
    systemComponents: {
      EMAIL_INGEST: "البريد الوارد (IMAP)",
      EMAIL_DISPATCH: "البريد الصادر (SMTP)",
      JOB_SCHEDULER: "المجدول",
      API: "الواجهة البرمجية",
    },
  },

  // Sidebar
  sidebar: {
    dashboard: "لوحة التحكم",
    roles: "الأدوار",
    users: "المستخدمين",
    settings: "الإعدادات",
    systemSettings: "التكاملات والإعدادات",
    userSettings: "إعدادات المستخدم",
    organizations: "المؤسسات",
    logout: "تسجيل الخروج",
    toggleMenu: "تبديل القائمة",
    toggleMenuClose: "إغلاق القائمة",
    management: "الإدارة",
    companies: "الشركات",
    emailAccounts: "حسابات البريد",
    dataSources: "مصادر البيانات",
    translations: "الترجمات",
  },

  // Settings
  settings: {
    title: "الإعدادات",
    subtitle: "إدارة إعدادات الشركة والمستخدم",
    companySettingsSubtitle: "الإعدادات العامة للشركة",
    userSettingsSubtitle: "إعداداتك الشخصية",
    securitySettingsSubtitle: "إدارة كلمة المرور والأمان",
    companySettings: "إعدادات الشركة",
    userSettings: "إعدادات المستخدم",
    general: "عام",
    personal: "شخصي",
    timezone: "المنطقة الزمنية",
    dateFormat: "تنسيق التاريخ",
    defaultCurrency: "العملة الافتراضية",
    defaultLanguage: "اللغة الافتراضية",
    language: "اللغة",
    companySettingsSaved: "تم حفظ إعدادات الشركة",
    userSettingsSaved: "تم حفظ إعدادات المستخدم",
    failedToLoad: "فشل تحميل الإعدادات",
    saveFailed: "فشل حفظ الإعدادات",
    profilePicture: "الصورة الشخصية",
    maxFileSize: "الحد الأقصى 5 ميجابايت. التنسيقات: JPEG, PNG, GIF, WebP",
    change: "تغيير",
    uploading: "جاري الرفع...",
    deleteAvatar: "حذف الصورة",
    deleteAvatarConfirm: "هل تريد حذف الصورة الشخصية؟",
    avatarUploaded: "تم رفع الصورة بنجاح",
    avatarDeleted: "تم حذف الصورة",
    avatarUploadError: "حدث خطأ أثناء الرفع",
    avatarDeleteError: "حدث خطأ أثناء الحذف",
    onlyImageFiles: "يسمح فقط بملفات الصور",
    fileSizeError: "يجب أن يكون حجم الملف أقل من 5 ميجابايت",
    appearance: "المظهر",
    theme: "السمة",
    light: "فاتح",
    dark: "داكن",
    pageSize: "حجم صفحة الجدول",
    defaultCompany: "الشركة الافتراضية",
    selectDefaultCompany: "اختر الشركة الافتراضية",
    noCompaniesAssigned: "لا توجد شركات معيّنة",
    security: "الأمان",
    changePassword: "تغيير كلمة المرور",
    currentPassword: "كلمة المرور الحالية",
    newPassword: "كلمة المرور الجديدة",
    confirmNewPassword: "تأكيد كلمة المرور الجديدة",
    passwordChanged: "تم تغيير كلمة المرور بنجاح",
    passwordChangeFailed: "فشل تغيير كلمة المرور",
    passwordMismatch: "كلمات المرور الجديدة غير متطابقة",
    passwordTooShort: "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
    passwordSameAsOld: "يجب أن تختلف كلمة المرور الجديدة عن الحالية",
    changingPassword: "جاري تغيير كلمة المرور...",
    pleaseSelectCompany: "يرجى اختيار شركة",
  },

  // Organizations
  organizations: {
    title: "المؤسسات",
    code: "الرمز",
    name: "اسم المؤسسة",
    description: "الوصف",
    logo: "الشعار",
    logoEmpty: "لا يوجد شعار",
    uploadLogo: "رفع شعار",
    status: "الحالة",
    smtp: "SMTP",
    imap: "IMAP",
    smtpEmailAccount: "حساب بريد SMTP",
    imapEmailAccount: "حساب بريد IMAP",
    active: "نشط",
    inactive: "غير نشط",
    newOrganization: "مؤسسة جديدة",
    editOrganization: "تعديل المؤسسة",
    deleteConfirm: "هل تريد حذف هذه المؤسسة؟",
    deleteFailed: "فشل حذف المؤسسة",
    operationFailed: "فشلت العملية",
    failedToLoad: "فشل تحميل المؤسسات",
    dataFormatError: "تنسيق بيانات المؤسسة غير متوقع",
    searchPlaceholder: "بحث في المؤسسات (الاسم، الوصف)",
    empty: "لا توجد بيانات",
    notSet: "غير محدد",
    noCreatePermission: "ليس لديك صلاحية إنشاء مؤسسة",
    noUpdatePermission: "ليس لديك صلاحية تعديل مؤسسة",
    noDeletePermission: "ليس لديك صلاحية حذف مؤسسة",
    company: "اسم الشركة",
    statusDistribution: "توزيع حالة المؤسسات",
  },

  // Users
  users: {
    title: "المستخدمين",
    newUser: "مستخدم جديد",
    editUser: "تعديل المستخدم",
    noUsersYet: "لا يوجد مستخدمون بعد",
    failedToLoad: "فشل تحميل المستخدمين",
    deleteConfirm: "هل تريد حذف هذا المستخدم؟",
    deleteFailed: "فشل الحذف",
    operationFailed: "فشلت العملية",
    passwordRequired: "كلمة المرور مطلوبة",
    passwordChangeHint: "(اتركه فارغاً إذا كنت لا تريد التغيير)",
    fullName: "الاسم الكامل",
    email: "البريد الإلكتروني",
    status: "الحالة",
    roles: "الأدوار",
    actions: "إجراءات",
    firstName: "الاسم الأول *",
    lastName: "اسم العائلة *",
    password: "كلمة المرور",
    noRoles: "لا توجد أدوار",
    rolesNotFound: "لم يتم العثور على أدوار",
    statusActive: "نشط",
    statusInactive: "غير نشط",
    statusSuspended: "معلق",
    userInfoFailed: "فشل تحميل معلومات المستخدم",
    rolesFailed: "فشل تحميل الأدوار",
    copy: "نسخ",
    isAdmin: "مسؤول",
    groups: "المجموعات",
    groupCount: "عدد المجموعات",
    userGroupName: "اسم المجموعة",
    userGroupCode: "رمز المجموعة",
    userGroupEmail: "بريد المجموعة",
    groupManager: "مدير المجموعة",
    members: "الأعضاء",
    userGroupDescription: "الوصف",
    userGroupCreate: "إنشاء مجموعة جديدة",
    userGroupEdit: "تعديل المجموعة",
    manageMembers: "إدارة الأعضاء",
    addMember: "إضافة عضو",
    memberCount: "عدد الأعضاء",
    searchUsers: "بحث عن مستخدمين...",
    noMembers: "لا يوجد أعضاء بعد",
    selectUser: "اختر مستخدماً",
    addUser: "إضافة",
    removeUser: "إزالة",
    manageGroups: "إدارة المجموعات",
    noUsersFound: "لم يتم العثور على مستخدمين",
    statusDistribution: "توزيع حالة المستخدمين",
    groupStatusDistribution: "توزيع حالة المجموعات",
  },

  // Roles
  roles: {
    title: "الأدوار",
    newRole: "دور جديد",
    editRole: "تعديل الدور",
    noRolesYet: "لا توجد أدوار بعد",
    failedToLoad: "فشل تحميل الأدوار",
    deleteConfirm: "هل تريد حذف هذا الدور؟",
    deleteFailed: "فشل الحذف",
    operationFailed: "فشلت العملية",
    dataFormatError: "خطأ في تنسيق البيانات",
    permissionsFailed: "فشل تحميل الصلاحيات",
    name: "اسم الدور *",
    description: "الوصف",
    permissions: "الصلاحيات",
    permissionCount: "عدد الصلاحيات",
    type: "نوع الدور",
    typeSystem: "نظام",
    typeCustom: "مخصص",
    typeAll: "جميع الأدوار",
    searchPlaceholder: "بحث (الاسم، الوصف، الصلاحية)...",
    systemBadge: "نظام",
    permissionsCount: "الصلاحيات ({count})",
    morePermissions: "+ {count} أخرى",
    copy: "نسخ",
    copySuffix: " (نسخة)",
    clearFilters: "مسح التصفية",
    noCreatePermission: "ليس لديك صلاحية إنشاء دور",
    noUpdatePermission: "ليس لديك صلاحية تعديل دور",
    noDeletePermission: "ليس لديك صلاحية حذف دور",
    systemRoleEditBlocked: "لا يمكن تعديل أدوار النظام",
    systemRoleDeleteBlocked: "لا يمكن حذف أدوار النظام",
    noPermissions: "لا توجد صلاحيات",
    paginationRange: "{start}-{end} من {total}",
    paginationPage: "صفحة {page} من {total}",
    modules: {
      users: "المستخدمين",
      groups: "المجموعات",
      userGroupName: "اسم المجموعة",
      userGroupCode: "رمز المجموعة",
      groupManager: "مدير المجموعة",
      members: "الأعضاء",
      userGroupDescription: "الوصف",
      userGroupCreate: "إنشاء مجموعة جديدة",
      userGroupEdit: "تعديل المجموعة",
      roles: "الأدوار",
      tenant: "العميل",
      userSettingField: "الإعداد",
      settings: "الإعدادات",
      organizations: "المؤسسات",
    },
    groups: "المجموعات",
    userGroup: "مجموعة المستخدمين",
    userGroupList: "قائمة المجموعات",
    userGroupCreate: "إنشاء مجموعة",
    userGroupEdit: "تعديل المجموعة",
    userGroupName: "اسم المجموعة",
    userGroupDescription: "الوصف",
    userGroupCode: "الرمز",
    groupManager: "مدير المجموعة",
    members: "الأعضاء",
    addMember: "إضافة عضو",
    assignRole: "تعيين دور",
    assign: "تعيين",
    statusDistribution: "توزيع حالة الأدوار",
    assignRoleMatrix: "مصفوفة الأدوار",
    roleMatrix: "مصفوفة الأدوار",
    selectCompanyToViewMatrix: "اختر شركة لعرض المصفوفة",
    show: "عرض",
    hide: "إخفاء",
    searchPermissions: "بحث عن صلاحيات...",
    permission: "الصلاحية",
    permissionsSelected: "تم اختيار {count} صلاحية",
  },

  // Companies
  companies: {
    title: "الشركات",
    newCompany: "شركة جديدة",
    editCompany: "تعديل الشركة",
    noCompaniesYet: "لا توجد شركات بعد",
    failedToLoad: "فشل تحميل الشركات",
    deleteConfirm: "هل تريد حذف هذه الشركة؟",
    deleteFailed: "فشل الحذف",
    operationFailed: "فشلت العملية",
    dataFormatError: "خطأ في تنسيق البيانات",
    name: "اسم الشركة *",
    status: "الحالة",
    statusActive: "نشط",
    statusInactive: "غير نشط",
    searchPlaceholder: "بحث (الاسم، الحالة)...",
    clearFilters: "مسح التصفية",
    copy: "نسخ",
    copySuffix: " (نسخة)",
    noCreatePermission: "ليس لديك صلاحية إنشاء شركة",
    noUpdatePermission: "ليس لديك صلاحية تعديل شركة",
    noDeletePermission: "ليس لديك صلاحية حذف شركة",
    paginationRange: "{start}-{end} من {total}",
    paginationPage: "صفحة {page} من {total}",
    allStatuses: "جميع الحالات",
    statusDistribution: "توزيع حالة الشركات",
    show: "عرض",
    hide: "إخفاء",
    logo: "الشعار",
    logoEmpty: "لا يوجد شعار",
    uploadLogo: "رفع شعار",
    smtpEmailAccount: "حساب SMTP",
    imapEmailAccount: "حساب IMAP",
    smtpEmailId: "حساب SMTP",
    imapEmailId: "حساب IMAP",
  },

  // Emails
  emails: {
    title: "حسابات البريد",
    newEmail: "حساب جديد",
    editEmail: "تعديل الحساب",
    noEmailsYet: "لا توجد حسابات بعد",
    failedToLoad: "فشل تحميل الحسابات",
    deleteConfirm: "حذف هذا الحساب؟",
    deleteConfirmMessage: "هل تريد حذف الحساب \"{name}\"؟",
    deleteFailed: "فشل الحذف",
    operationFailed: "فشلت العملية",
    dataFormatError: "خطأ في تنسيق البيانات",
    name: "اسم الحساب",
    type: "النوع",
    host: "المضيف",
    port: "المنفذ",
    user: "اسم المستخدم",
    password: "كلمة المرور",
    fromEmail: "بريد المرسل",
    secure: "آمن (SSL/TLS)",
    secureConnection: "اتصال آمن (SSL/TLS)",
    status: "الحالة",
    statusActive: "نشط",
    statusInactive: "غير نشط",
    activate: "تفعيل",
    deactivate: "تعطيل",
    isActive: "نشط",
    searchPlaceholder: "بحث (الاسم، المضيف، المستخدم)...",
    clearFilters: "مسح التصفية",
    copy: "نسخ",
    noCreatePermission: "ليس لديك صلاحية إنشاء حساب",
    noUpdatePermission: "ليس لديك صلاحية تعديل حساب",
    noDeletePermission: "ليس لديك صلاحية حذف حساب",
    paginationRange: "{start}-{end} من {total}",
    paginationPage: "صفحة {page} من {total}",
    allStatuses: "جميع الحالات",
    allTypes: "جميع الأنواع",
    statusDistribution: "توزيع حالة الحسابات",
    show: "عرض",
    hide: "إخفاء",
    nameRequired: "اسم الحساب مطلوب",
    hostRequired: "المضيف مطلوب",
    portRequired: "المنفذ مطلوب",
    userRequired: "اسم المستخدم مطلوب",
    passwordRequired: "كلمة المرور مطلوبة",
    leaveBlankToKeep: "اتركه فارغاً للحفاظ على الحالي",
    noData: "لا توجد بيانات",
    noEmailsMessage: "لم يتم العثور على حسابات",
    passwordEditHint: "اتركه فارغاً إذا كنت لا تريد التغيير",
    noSearchResults: "لم يتم العثور على نتائج",
    namePlaceholder: "مثال: الدعم أو info@company.com",
    deleteConfirmTitle: "حذف الحساب",
  },

  // Login
  login: {
    title: "QubePro ERP",
    subtitle: "تخطيط موارد المؤسسة",
    heroTitle: "إدارة أعمالك من مركز واحد",
    heroSubtitle: "يجمع QubePro ERP إدارة الشركات والمؤسسات والمستخدمين والأدوار في منصة واحدة آمنة.",
    languageToggleLabel: "اللغة",
    turkish: "التركية",
    english: "الإنجليزية",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    emailPlaceholder: "example@domain.com",
    emailHint: "يتم تحديد العميل تلقائياً من النطاق",
    passwordPlaceholder: "••••••••",
    loginButton: "تسجيل الدخول",
    loggingIn: "جاري الدخول...",
    loginFailed: "فشل تسجيل الدخول",
    darkMode: "الوضع الداكن",
    lightMode: "الوضع الفاتح",
    loginPageTitle: "تسجيل الدخول",
    submitButton: "تسجيل الدخول",
    featureTitle: "نظام الإدارة المركزي",
    featureDescription: "إدارة علاقات العملاء والمبيعات والمخزون والعمليات المالية في منصة متكاملة واحدة.",
    featureCard1Title: "إدارة العملاء",
    featureCard1Description: "تتبع عملاءك والمبيعات المحتملة وعلاقات العمل من موقع مركزي.",
    featureCard2Title: "المبيعات والطلبات",
    featureCard2Description: "إدارة العروض والطلبات وعمليات البيع بسهولة لزيادة الإيرادات.",
    featureCard3Title: "التقارير والتحليلات",
    featureCard3Description: "مراقبة أداء الأعمال بتقارير في الوقت الفعلي لاتخاذ قرارات مبنية على البيانات.",
    featureCard4Title: "إعدادات النظام",
    featureCard4Description: "خصص نظامك وادمجه مع أدوات أخرى وأتمت عمليات أعمالك.",
    pleaseWait: "يرجى الانتظار",
    serverConfiguring: "جاري تهيئة الخادم، يرجى الانتظار...",
    dbCreating: "جاري إنشاء قاعدة البيانات والتكوينات اللازمة. قد يستغرق هذا بضع ثوانٍ.",
    emailLabel: "البريد الإلكتروني",
    passwordLabel: "كلمة المرور",
    emailPlaceholderFull: "يرجى إدخال البريد الإلكتروني",
    passwordPlaceholderFull: "يرجى إدخال كلمة المرور",
    showPassword: "عرض",
    hidePassword: "إخفاء",
    emailRequired: "البريد الإلكتروني مطلوب",
    passwordRequired: "كلمة المرور مطلوبة",
    backendUnavailable: "الخادم غير متاح حالياً. يرجى المحاولة لاحقاً.",
    backendConnectFailed: "فشل الاتصال بالخادم. يرجى المحاولة لاحقاً.",
    backendConnectFailedDev: "فشل الاتصال. تأكد من تشغيل الخادم ({apiUrl}).",
    fieldEmail: "البريد",
    fieldPassword: "كلمة المرور",
    errors: {
      invalidCredentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
      databaseUnavailable: "قاعدة البيانات غير متاحة أو تحتاج لتهيئة. حاول الدخول مجدداً.",
      accountInactive: "حسابك غير نشط. يرجى مراجعة المسؤول.",
      sessionExpired: "انتهت صلاحية الجلسة. يرجى تسجيل الدخول مرة أخرى.",
      tooManyAttempts: "محاولات كثيرة جداً. يرجى المحاولة لاحقاً.",
      sessionTooLarge: "بيانات الجلسة كبيرة جداً. يرجى المحاولة مجدداً.",
    },
  },

  // DataSources
  dataSources: {
    title: "مصادر البيانات",
    subtitle: "إدارة الاتصالات بقواعد بيانات العملاء",
    newDataSource: "مصدر بيانات جديد",
    editDataSource: "تعديل مصدر البيانات",
    noDataSourcesYet: "لا توجد مصادر بيانات بعد",
    failedToLoad: "فشل تحميل مصادر البيانات",
    deleteConfirm: "هل تريد حذف هذا المصدر؟",
    deleteFailed: "فشل الحذف",
    operationFailed: "فشلت العملية",
    dataFormatError: "خطأ في تنسيق البيانات",
    name: "الاسم المعروض",
    driver: "المحرك",
    server: "الخادم",
    port: "المنفذ",
    databaseName: "اسم القاعدة",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    schema: "المخطط",
    sourceType: "نوع المصدر",
    source: "المصدر",
    target: "الهدف",
    sourceSystem: "النظام المصدر",
    targetSystem: "النظام الهدف",
    status: "الحالة",
    statusActive: "نشط",
    statusInactive: "غير نشط",
    searchPlaceholder: "بحث (الاسم، الخادم، القاعدة)...",
    clearFilters: "مسح التصفية",
    copy: "نسخ",
    paginationRange: "{start}-{end} / {total}",
    paginationPage: "صفحة {page} من {total}",
    allStatuses: "جميع الحالات",
    allTypes: "الكل",
    statusDistribution: "توزيع حالة مصادر البيانات",
    show: "عرض",
    hide: "إخفاء",
    nameRequired: "الاسم مطلوب",
    serverRequired: "عنوان الخادم مطلوب",
    databaseRequired: "اسم القاعدة مطلوب",
    passwordRequired: "كلمة المرور مطلوبة",
    testConnection: "اختبار الاتصال",
    testing: "جاري الاختبار...",
    testSuccess: "تم الاتصال بنجاح!",
    testFailed: "فشل الاتصال: ",
    integratedSecurity: "الأمان المتكامل",
    ssl: "SSL",
    connectionTimeout: "مهلة الاتصال (ثانية)",
    description: "الوصف",
    noCreatePermission: "ليس لديك صلاحية إنشاء مصدر بيانات",
    noUpdatePermission: "ليس لديك صلاحية تعديل مصدر بيانات",
    noDeletePermission: "ليس لديك صلاحية حذف مصدر بيانات",
  },

  aiProviders: {
    title: "مزودي الذكاء الاصطناعي",
    subtitle: "إدارة نماذج الذكاء الاصطناعي والتكاملات",
    newProvider: "مزود جديد",
    editProvider: "تعديل المزود",
    noProvidersYet: "لا توجد بيانات",
    failedToLoad: "فشل تحميل المزودين",
    deleteConfirm: "هل أنت متأكد من حذف هذا المزود؟",
    deleteFailed: "فشل حذف المزود",
    operationFailed: "فشلت العملية",
    name: "اسم المزود *",
    provider: "نوع المزود",
    baseUrl: "الرابط الأساسي (URL)",
    apiKey: "مفتاح API",
    description: "الوصف",
    status: "الحالة",
    statusActive: "نشط",
    statusInactive: "غير نشط",
    searchPlaceholder: "بحث (الاسم، النوع، الرابط)...",
    clearFilters: "مسح التصفية",
    noCreatePermission: "ليس لديك صلاحية إنشاء مزود",
    statusDistribution: "توزيع حالة مزودي الذكاء الاصطناعي",
    baseUrlPlaceholder: "مثال: http://localhost:11434, https://api.custom.ai/v1",
    baseUrlEmptyDefault: "اتركه فارغاً للقيم الافتراضية",
    apiKeyPlaceholder: "أدخل مفتاح API",
  },
};
